import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
import { useI18n } from '../contexts/I18nContext';

interface ThemeToggleProps {
  className?: string;
}

export function ThemeToggle({ className = '' }: ThemeToggleProps) {
  const { theme, toggleTheme } = useTheme();
  const { tt } = useI18n();
  const label = theme === 'light' ? tt('Switch to dark mode') : tt('Switch to light mode');
  
  return (
    <button
      onClick={toggleTheme}
      className={`p-2 rounded-lg text-theme-text-secondary hover:text-theme-text hover:bg-theme-surface-hover transition-colors ${className}`}
      title={label}
      aria-label={label}
    >
      {theme === 'light' ? (
        <Moon className="h-5 w-5" />
      ) : (
        <Sun className="h-5 w-5" />
      )}
    </button>
  );
}
